import { useEffect } from 'react'
import { BasePage, type BasePageProps } from './BasePage'
import { PageProvider } from './context'
import {
  Header,
  SideMenu,
  BottomMenu,
  Content,
  ContentRow,
  InnerPullToRefresh,
  type InnerPullToRefreshProps,
} from './components'

export type PageWithRefreshProps = BasePageProps & InnerPullToRefreshProps

/**
 * Page which you can also use to refresh content. When not every route
 * needs refreshing you can set `disablePullDown` or not give `onRefresh`.
 */
const PageWithRefresh = ({
  children,
  disablePullDown = false,
  onRefresh,
  sideMenuOptions,
  ...rest
}: PageWithRefreshProps) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0)
    }
  }, [onRefresh])

  return (
    <PageProvider sideMenuOptions={sideMenuOptions} hasSideMenu={!!rest.sideMenu} noPrintHeader={rest.noPrintHeader}>
      <BasePage {...rest}>
        <InnerPullToRefresh onRefresh={onRefresh} disablePullDown={disablePullDown}>
          {children}
        </InnerPullToRefresh>
      </BasePage>
    </PageProvider>
  )
}

PageWithRefresh.BottomMenu = BottomMenu

/**
 * A container where we set the content distance based on the theme correctly.
 *
 * @example <Page><Page.Content isFullView>your application content</Page.Content></Page>
 */
PageWithRefresh.Content = Content

/**
 * Our mobile version is a full wide screen, this ContentRow can be used when
 * it does need indentation for a specific row. This indentation will only be
 * added on mobile variants.
 * @warning will add indentation only on MOBILE
 */
PageWithRefresh.ContentRow = ContentRow
PageWithRefresh.Header = Header
PageWithRefresh.SideMenu = SideMenu

export { PageWithRefresh }
